import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DemoMaterialModule } from './material-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { UserPolicyComponent } from './user-policy/user-policy.component';
import { FaqComponent } from './faq/faq.component';
import { ItemDetailComponent } from './item-detail/item-detail.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LdkDetailComponent } from './ldk-detail/ldk-detail.component';
import { QuestantRedirectComponent } from './questant-redirect/questant-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    UserPolicyComponent,
    FaqComponent,
    ItemDetailComponent,
    LdkDetailComponent,
    QuestantRedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DemoMaterialModule,
    BrowserAnimationsModule,
    SlickCarouselModule,
    HttpClientModule,
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
